module.exports = __webpack_public_path__ + "media/notice_1.cdb218ab.mp3";